import IPerguntaDeMoradiaValidacaoCampos, { IPerguntaDeMoradiaValidacaoErroCampos } from '../../interfaces/IPerguntaDeMoradiaValidacao';

let _situacao: string | undefined;
let _valorDoAluguel: number | undefined;
let _materialDaConstrucao: string | undefined;
let _moraEmAreaDeRisco: boolean | undefined;
let _areasDeRisco: string[] | undefined;
let _onusExcessivo: boolean | undefined;
let _adensamentoExcessivo: boolean | undefined;
let _habitacaoPrecaria: boolean | undefined;
let _possuiComprovacaoDaAreaDeRisco: boolean | undefined;
let _ehAcessoAdministrativo: boolean | undefined;

const situacaoObrigatorio = () => {
  if (_situacao === undefined || _situacao == '')
    return true;
};

const valorDoAluguelObrigatorio = () => {
  if (_situacao == 'Alugada' && _valorDoAluguel === 0)
    return true;
};

const materialDaConstrucaoObrigatorioSeSituacaoNaoForDeRua = () => {
  if ((_materialDaConstrucao == undefined || _materialDaConstrucao == '' || _materialDaConstrucao == '0') && (_situacao ==='AluguelSocial' || _situacao === 'Alugada'))
    return true;
};

const moraEmAreadeRiscoObrigatorio = () => {
  if (_moraEmAreaDeRisco == undefined)
    return true;
};

const areasDeRiscoObrigatorio = () => {
  const possuiAreasDeRisco = _areasDeRisco != undefined && _areasDeRisco.length > 0;

  if (_moraEmAreaDeRisco && !possuiAreasDeRisco)
    return true;
};

const adensamentoExcessivoObrigatorioSeSituacaoNaoForEmSituacaoDeRua = () => {
  if (_adensamentoExcessivo == undefined && (_situacao ==='AluguelSocial' || _situacao === 'Alugada'))
    return true;
};

const habitacaoPrecariaObrigatorio = () => {
  if (_habitacaoPrecaria == undefined)
    return true;
};

const onusExcessioObrigatorio = () => {
  if (_onusExcessivo == undefined && _situacao === 'Alugada')
    return true;
};

const possuiComprovacaoDaAreaDeRiscoObrigatorio = () => {
  if (_ehAcessoAdministrativo && _moraEmAreaDeRisco && _possuiComprovacaoDaAreaDeRisco == undefined)
    return true;
};

const validacoes: IPerguntaDeMoradiaValidacaoCampos = {
  situacao: [situacaoObrigatorio],
  valorDoAluguel: [valorDoAluguelObrigatorio],
  materialDaConstrucao: [materialDaConstrucaoObrigatorioSeSituacaoNaoForDeRua],
  moraEmAreaDeRisco: [moraEmAreadeRiscoObrigatorio],
  areasDeRisco: [areasDeRiscoObrigatorio],
  onusExcessivo: [onusExcessioObrigatorio],
  adensamentoExcessivo: [adensamentoExcessivoObrigatorioSeSituacaoNaoForEmSituacaoDeRua],
  habitacaoPrecaria:[habitacaoPrecariaObrigatorio],
  possuiComprovacaoDaAreaDeRisco:[possuiComprovacaoDaAreaDeRiscoObrigatorio]
};

const aplicarFuncoesDeValidacao = (ehAcessoAdministrativo: boolean, campo: string, situacao: string, valorDoAluguel: number | undefined, materialDaConstrucao: string,
  moraEmAreaDeRisco: boolean, areasDeRisco: string[], onusExcessivo?: boolean, adensamentoExcessivo?: boolean, habitacaoPrecaria?: boolean, possuiComprovacaoDaAreaDeRisco?: boolean) => {

  //@ts-ignore
  const funcoes = validacoes[campo] || [];
  _situacao = situacao;
  _valorDoAluguel = valorDoAluguel;
  _materialDaConstrucao = materialDaConstrucao;
  _moraEmAreaDeRisco = moraEmAreaDeRisco;
  _areasDeRisco = areasDeRisco;
  _onusExcessivo = onusExcessivo;
  _adensamentoExcessivo = adensamentoExcessivo;
  _habitacaoPrecaria = habitacaoPrecaria;
  _possuiComprovacaoDaAreaDeRisco = possuiComprovacaoDaAreaDeRisco;
  _ehAcessoAdministrativo = ehAcessoAdministrativo;

  const retornosComErro = funcoes.map((f: Function) => f.call(campo)).filter((r: any) => !!r);

  return retornosComErro[0];
};

const validarFormulario = ( ehAcessoAdministrativo: boolean, situacao: string, valorDoAluguel: number | undefined, materialDaConstrucao: string, moraEmAreaDeRisco: boolean, areasDeRisco: string[],
  onusExcessivo?: boolean, adensamentoExcessivo?: boolean, habitacaoPrecaria?: boolean, possuiComprovacaoDaAreaDeRisco?: boolean): IPerguntaDeMoradiaValidacaoErroCampos => {

  const errosValidacao: IPerguntaDeMoradiaValidacaoErroCampos = Object.keys(validacoes).reduce((erros, campo) => {
    //@ts-ignore
    const erro = aplicarFuncoesDeValidacao(ehAcessoAdministrativo, campo, situacao, valorDoAluguel, materialDaConstrucao, moraEmAreaDeRisco, areasDeRisco, onusExcessivo, adensamentoExcessivo, habitacaoPrecaria, possuiComprovacaoDaAreaDeRisco);
    if (erro)
      return { ...erros, [campo]: erro };

    return erros;
  }, {});

  return errosValidacao;
};

export default { validarCampo: aplicarFuncoesDeValidacao, validarFormulario };